<div class="scad-sidebar">
    <div class="scad-sidebar__head">
      <div class="scad-sidebar__head__name">Tools</div>
      <div><img src="/assets/images/svg/click-side.svg" alt="" /></div>
    </div>

    <div class="pt-4 pb-4">
      <div class="scad-input scad-input--search-right">
        <div class="scad-input__search-icon">
          <em class="scad-icon scad-icon-Search"></em>
        </div>
        <input type="text" class="scad-input scad-input--search-right" placeholder="Search.."/>
      </div>
    </div>

    <div class="scad-sidebar__main-menu">
      <ul class="scad-sidebar__side-menu">

        <li class="scad-sidebar__side-item" *ngFor="let item of _flowBuilder.sidebar_data; let outerIndex = index" >
          <a class="scad-sidebar__item" id="{{outerIndex}}" >

            <img src="{{item.icon}}" alt="" />
            <label for="{{outerIndex}}">{{item.name}}
            </label>

            <div class="scad-sidebar__arrow-action" (click)="collapse(outerIndex)">
              <svg *ngIf="item.isOpen"  xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path d="M16.8666 11.5H6.1333" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="!item.isOpen" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path d="M11.1166 4.6001V17.6517" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17.6333 11.1167H4.59998" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

          </a>
          <ul class="scad-sidebar__sub-side-menu" *ngIf="item.isOpen">
            <div class="scad-sidebar__sub-side-item" *ngFor="let subItem of item.submenu;let innerIndex = index"
           >
              <a class="scad-sidebar__sub-item"  draggable="true" [id]="subItem?.name" (dragstart)="onDragStart($event,outerIndex,innerIndex)">
                <img class="sub-icon" src="{{subItem.icon}}" alt="" />
                <span>{{subItem.name}}</span>
              </a>
            </div>
          </ul>
        </li>
      </ul>
    </div>
  </div>


